/*! Bead Yours - templates, pet maker and text stamping for the Perler builder.
    Needs by-core.js and by-templates-data.js. */
(function (g) {
  'use strict';
  var BY = g.BeadYours = g.BeadYours || {};

  // Convert an ASCII template to a grid of palette ids
  BY.templateGrid = function (tpl, keyOverride) {
    var keys = Object.assign({}, BY.TPL_KEYS || {}, keyOverride || {});
    var w = tpl.w, h = tpl.h, grid = new Uint8Array(w * h);
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      var ch = tpl.rows[y][x];
      if (ch !== '.' && keys[ch]) grid[y * w + x] = BY.perlerId(keys[ch]);
    }
    return { w: w, h: h, grid: grid };
  };

  /* ------------------------------------------------------------------ *
   * Pet maker: layered pixel parts + breed presets
   * Roles: b base coat, s muzzle, a ear, i inner ear, x marking, y marking 2,
   *        e eye, W glint, n nose, m mouth, t tongue, c iris (cats), k pupil
   * ------------------------------------------------------------------ */
  function rows(str) { return str.trim().split('\n').map(function (r) { return r.trim(); }); }
  // A part = list of [x, y, role] cells built from ascii placed at (ox, oy); '.' skipped
  function part(ascii, ox, oy) {
    var out = [];
    rows(ascii).forEach(function (r, y) {
      for (var x = 0; x < r.length; x++) if (r[x] !== '.' && r[x] !== ' ') out.push([ox + x, oy + y, r[x]]);
    });
    return out;
  }
  function mirror(cells, W) { return cells.map(function (c) { return [W - 1 - c[0], c[1], c[2]]; }); }
  function both(cells, W) { return cells.concat(mirror(cells, W)); }

  var DOG = { W: 23, H: 20 };
  DOG.head = part(
    '.....bbbbbbb.....\n' +
    '...bbbbbbbbbbb...\n' +
    '..bbbbbbbbbbbbb..\n' +
    '.bbbbbbbbbbbbbbb.\n' +
    '.bbbbbbbbbbbbbbb.\n' +
    '.bbbWebbbbbWebbb.\n' +
    '.bbbeebbbbbeebbb.\n' +
    '.bbbbbbbbbbbbbbb.\n' +
    '.bbbbbbsssbbbbbb.\n' +
    '..bbbbsssssbbbb..\n' +
    '..bbbssnnnssbbb..\n' +
    '...bbssnnnssbb...\n' +
    '...bbsssnsssbb...\n' +
    '....bssmsmssb....\n' +
    '.....sstttss.....\n' +
    '.......sts.......', 3, 4);
  DOG.ears = {
    floppy: { front: both(part(
      '....aaaaa\n' +
      '...aaaaa.\n' +
      '..aaaaa..\n' +
      '.aaaaa...\n' +
      '.aaaaa...\n' +
      '.aaaaa...\n' +
      '.aaaaa...\n' +
      '.aaaa....\n' +
      '..aaa....\n' +
      '..aa.....', 0, 4), DOG.W) },
    pointy: { back: both(part(
      '..a...\n' +
      '.aia..\n' +
      '.aiia.\n' +
      'aiiiia\n' +
      'aiiiia\n' +
      'aaaaa.', 4, 0), DOG.W) },
    bat: { back: both(part(
      'aa....\n' +
      'aia...\n' +
      'aiia..\n' +
      'aiiia.\n' +
      'aiiiia\n' +
      '.aaaaa\n' +
      '.aa...', 3, 0), DOG.W) },
    folded: { front: both(part(
      '.aaaa\n' +
      'aaaaa\n' +
      'aaaa.\n' +
      '.aa..', 4, 3), DOG.W) }
  };
  DOG.marks = {
    none: [],
    blaze: part('x\nx\nx\nx\nx', 11, 4).concat(part('xxx\nxxx', 10, 9)),
    eyepatch: part('.xxxx.\nxxxxxx\nxxxxxx\nxxxxxx\n.xxxx.', 5, 7),
    eyepatches: both(part('.xxxx.\nxxxxxx\nxxxxxx\nxxxxxx\n.xxxx.', 5, 7), DOG.W),
    spots: part('xx', 6, 6).concat(part('x\nx', 15, 5), part('xx', 9, 4), part('xx\nxx', 16, 8),
      part('x', 13, 7), part('xx', 5, 12), part('x\nx', 17, 12), part('x', 8, 15), part('xx', 14, 16)),
    tanpoints: part('xx', 7, 8).concat(part('xx', 14, 8)),
    cap: part(
      '.....xxxxxxx.....\n' +
      '...xxxxxxxxxxx...\n' +
      '..xxxxxxxxxxxxx..\n' +
      '.xxxxxxxxxxxxxxx.\n' +
      '.xxx..xxxxx..xxx.\n' +
      '.xx.....x.....xx.', 3, 4)
  };

  var CAT = { W: 19, H: 17 };
  CAT.head = part(
    '.....bbbbbbbbb.....\n' +
    '...bbbbbbbbbbbbb...\n' +
    '..bbbbbbbbbbbbbbb..\n' +
    '.bbbbbbbbbbbbbbbbb.\n' +
    '.bbbcWcbbbbbcWcbbb.\n' +
    '.bbbckcbbbbbckcbbb.\n' +
    '.bbbbbbbbbbbbbbbbb.\n' +
    '.bbbbbbbsnsbbbbbbb.\n' +
    '..bbbbbsssssbbbbb..\n' +
    '..bbbbssmsmssbbbb..\n' +
    '...bbbbsssssbbbb...\n' +
    '....bbbbbbbbbbb....\n' +
    '......bbbbbbb......', 0, 4);
  CAT.ears = {
    pointy: { back: both(part(
      'a....\n' +
      'aa...\n' +
      'aia..\n' +
      'aiia.\n' +
      'aiiia', 3, 0), CAT.W) },
    folded: { front: both(part(
      '.aaa.\n' +
      'aaaa.\n' +
      '.aa..', 3, 3), CAT.W) }
  };
  CAT.marks = {
    none: [],
    tabby: part('x.x.x', 7, 4).concat(part('x.x.x', 7, 5), part('x...x', 7, 6), part('xx', 1, 10), part('xx', 16, 10), part('xx', 1, 12), part('xx', 16, 12)),
    tuxedo: part(
      '.......xxxxx.......\n' +
      '......xxxxxxx......\n' +
      '....xxxxxxxxxxx....\n' +
      '......xxxxxxx......', 0, 13).concat(part('x\nx\nx\nx\nx', 9, 6)),
    calico: part(
      '.xxxx\n' +
      'xxxxxx\n' +
      'xxxxx\n' +
      'xxx', 2, 5).concat(part(
      '...yy\n' +
      '..yyyy\n' +
      '.yyyyy\n' +
      '..yyy', 12, 10)),
    siamese: part(
      '.....xxxxx.....\n' +
      '...xxxxxxxxx...\n' +
      '..xxxxxxxxxxx..\n' +
      '..xxxxxxxxxxx..\n' +
      '...xxxxxxxxx...\n' +
      '....xxxxxxx....', 2, 8),
    bicolor: part(
      '..xxxxxxxxxxxxx..\n' +
      '...xxxxxxxxxxx...\n' +
      '....xxxxxxxxx....\n' +
      '......xxxxx......', 1, 13)
  };

  BY.PET_SPECIES = { dog: DOG, cat: CAT };
  BY.PET_EARS = { dog: ['floppy', 'pointy', 'bat', 'folded'], cat: ['pointy', 'folded'] };
  BY.PET_MARKS = { dog: ['none', 'blaze', 'eyepatch', 'eyepatches', 'spots', 'tanpoints', 'cap'], cat: ['none', 'tabby', 'tuxedo', 'calico', 'siamese', 'bicolor'] };
  BY.PET_MARK_NAMES = { none: 'None', blaze: 'White blaze', eyepatch: 'Eye patch', eyepatches: 'Two eye patches', spots: 'Spots',
    tanpoints: 'Tan eyebrows', cap: 'Dark cap', tabby: 'Tabby stripes', tuxedo: 'Tuxedo', calico: 'Calico patches', siamese: 'Siamese mask', bicolor: 'White chin' };
  BY.PET_EAR_NAMES = { floppy: 'Floppy', pointy: 'Pointy', bat: 'Big bat ears', folded: 'Folded' };

  // p: {species, ears, mark, base, muzzle, ear, inner, mark1, mark2, eye, nose, tongue}
  BY.composePet = function (p) {
    var S = BY.PET_SPECIES[p.species] || DOG;
    var W = S.W, H = S.H, grid = new Uint8Array(W * H), role = new Array(W * H);
    var ears = S.ears[p.ears] || S.ears[Object.keys(S.ears)[0]];
    var cat = p.species === 'cat';
    var colors = {
      b: p.base, s: p.muzzle || p.base, a: p.ear || p.base, i: p.inner || (cat ? 'P79' : p.ear || p.base),
      x: p.mark1 || 'P01', y: p.mark2 || 'P18', e: p.eye || 'P18', W: 'P01', n: p.nose || (cat ? 'P83' : 'P18'),
      m: p.mouth || (cat ? 'P92' : 'P18'), t: p.tongue || 'P83', c: p.eye || 'P80', k: 'P18'
    };
    function put(cells, onlyRoles) {
      cells.forEach(function (c) {
        var x = c[0], y = c[1];
        if (x < 0 || y < 0 || x >= W || y >= H) return;
        var i = y * W + x;
        if (onlyRoles && onlyRoles.indexOf(role[i]) < 0) return;
        role[i] = c[2];
      });
    }
    if (ears.back) put(ears.back);
    put(S.head);
    var mk = S.marks[p.mark] || [];
    // markings only recolor coat (and muzzle for chin/tuxedo style marks)
    put(mk, ['b', 's', 'a']);
    if (ears.front) put(ears.front);
    // calico / siamese ears follow the marking color on that side
    if (cat && p.mark === 'siamese') { for (var i = 0; i < role.length; i++) if (role[i] === 'a') role[i] = 'x'; }
    for (var j = 0; j < role.length; j++) if (role[j]) grid[j] = BY.perlerId(colors[role[j]]) || 0;
    return { w: W, h: H, grid: grid };
  };

  BY.PET_PRESETS = [
    { id: 'lab-yellow', name: 'Yellow Lab', species: 'dog', ears: 'floppy', mark: 'none', base: 'P35', muzzle: 'P98', ear: 'P90' },
    { id: 'lab-black', name: 'Black Lab', species: 'dog', ears: 'floppy', mark: 'none', base: 'P18', muzzle: 'P92', ear: 'P18', eye: 'P21' },
    { id: 'lab-chocolate', name: 'Chocolate Lab', species: 'dog', ears: 'floppy', mark: 'none', base: 'P12', muzzle: 'P21', ear: 'P262' },
    { id: 'golden', name: 'Golden Retriever', species: 'dog', ears: 'floppy', mark: 'none', base: 'P90', muzzle: 'P98', ear: 'P21' },
    { id: 'gsd', name: 'German Shepherd', species: 'dog', ears: 'pointy', mark: 'none', base: 'P90', muzzle: 'P18', ear: 'P18', inner: 'P92' },
    { id: 'husky', name: 'Husky', species: 'dog', ears: 'pointy', mark: 'cap', base: 'P01', muzzle: 'P01', ear: 'P92', inner: 'P181', mark1: 'P92', eye: 'P09' },
    { id: 'dalmatian', name: 'Dalmatian', species: 'dog', ears: 'floppy', mark: 'spots', base: 'P01', muzzle: 'P01', ear: 'P18', mark1: 'P18' },
    { id: 'beagle', name: 'Beagle', species: 'dog', ears: 'floppy', mark: 'blaze', base: 'P90', muzzle: 'P01', ear: 'P12', mark1: 'P01' },
    { id: 'pug', name: 'Pug', species: 'dog', ears: 'folded', mark: 'none', base: 'P35', muzzle: 'P18', ear: 'P18' },
    { id: 'chihuahua', name: 'Chihuahua', species: 'dog', ears: 'bat', mark: 'none', base: 'P57', muzzle: 'P98', ear: 'P57', inner: 'P79' },
    { id: 'corgi', name: 'Corgi', species: 'dog', ears: 'pointy', mark: 'blaze', base: 'P90', muzzle: 'P01', ear: 'P90', inner: 'P79', mark1: 'P01' },
    { id: 'boxer', name: 'Boxer', species: 'dog', ears: 'folded', mark: 'blaze', base: 'P21', muzzle: 'P18', ear: 'P21', mark1: 'P01' },
    { id: 'pitbull', name: 'Pit Bull', species: 'dog', ears: 'folded', mark: 'blaze', base: 'P17', muzzle: 'P01', ear: 'P17', mark1: 'P01' },
    { id: 'border-collie', name: 'Border Collie', species: 'dog', ears: 'folded', mark: 'blaze', base: 'P18', muzzle: 'P01', ear: 'P18', mark1: 'P01', eye: 'P21' },
    { id: 'frenchie', name: 'French Bulldog', species: 'dog', ears: 'bat', mark: 'none', base: 'P35', muzzle: 'P92', ear: 'P35', inner: 'P79' },
    { id: 'boston', name: 'Boston Terrier', species: 'dog', ears: 'bat', mark: 'blaze', base: 'P18', muzzle: 'P01', ear: 'P18', inner: 'P92', mark1: 'P01', eye: 'P21' },
    { id: 'rottweiler', name: 'Rottweiler', species: 'dog', ears: 'floppy', mark: 'tanpoints', base: 'P18', muzzle: 'P20', ear: 'P18', mark1: 'P20', eye: 'P21' },
    { id: 'doberman', name: 'Doberman', species: 'dog', ears: 'pointy', mark: 'tanpoints', base: 'P18', muzzle: 'P20', ear: 'P18', inner: 'P20', mark1: 'P20', eye: 'P21' },
    { id: 'dachshund', name: 'Dachshund', species: 'dog', ears: 'floppy', mark: 'none', base: 'P20', muzzle: 'P90', ear: 'P12' },
    { id: 'shiba', name: 'Shiba Inu', species: 'dog', ears: 'pointy', mark: 'none', base: 'P90', muzzle: 'P01', ear: 'P90', inner: 'P01' },
    { id: 'poodle', name: 'White Poodle', species: 'dog', ears: 'floppy', mark: 'none', base: 'P01', muzzle: 'P01', ear: 'P181' },
    { id: 'shih-tzu', name: 'Shih Tzu', species: 'dog', ears: 'floppy', mark: 'eyepatches', base: 'P01', muzzle: 'P01', ear: 'P90', mark1: 'P90' },
    { id: 'yorkie', name: 'Yorkie', species: 'dog', ears: 'pointy', mark: 'cap', base: 'P90', muzzle: 'P90', ear: 'P90', inner: 'P79', mark1: 'P92' },
    { id: 'jack-russell', name: 'Jack Russell', species: 'dog', ears: 'folded', mark: 'eyepatch', base: 'P01', muzzle: 'P01', ear: 'P12', mark1: 'P90' },
    { id: 'aussie', name: 'Blue Merle Aussie', species: 'dog', ears: 'folded', mark: 'spots', base: 'P181', muzzle: 'P01', ear: 'P92', mark1: 'P92', eye: 'P09' },
    { id: 'cat-black', name: 'Black Cat', species: 'cat', ears: 'pointy', mark: 'none', base: 'P18', muzzle: 'P18', ear: 'P18', eye: 'P03', nose: 'P83', mouth: 'P92' },
    { id: 'cat-white', name: 'White Cat', species: 'cat', ears: 'pointy', mark: 'none', base: 'P01', muzzle: 'P01', ear: 'P01', eye: 'P09' },
    { id: 'cat-orange', name: 'Orange Tabby', species: 'cat', ears: 'pointy', mark: 'tabby', base: 'P57', muzzle: 'P01', ear: 'P57', mark1: 'P04', eye: 'P80' },
    { id: 'cat-gray', name: 'Gray Tabby', species: 'cat', ears: 'pointy', mark: 'tabby', base: 'P17', muzzle: 'P181', ear: 'P17', mark1: 'P92', eye: 'P03' },
    { id: 'cat-brown', name: 'Brown Tabby', species: 'cat', ears: 'pointy', mark: 'tabby', base: 'P21', muzzle: 'P35', ear: 'P21', mark1: 'P12', eye: 'P80' },
    { id: 'cat-tuxedo', name: 'Tuxedo Cat', species: 'cat', ears: 'pointy', mark: 'tuxedo', base: 'P18', muzzle: 'P01', ear: 'P18', mark1: 'P01', eye: 'P03' },
    { id: 'cat-calico', name: 'Calico', species: 'cat', ears: 'pointy', mark: 'calico', base: 'P01', muzzle: 'P01', ear: 'P01', mark1: 'P04', mark2: 'P18', eye: 'P80' },
    { id: 'cat-siamese', name: 'Siamese', species: 'cat', ears: 'pointy', mark: 'siamese', base: 'P02', muzzle: 'P262', ear: 'P262', inner: 'P262', mark1: 'P262', eye: 'P09', nose: 'P18' },
    { id: 'cat-russian', name: 'Russian Blue', species: 'cat', ears: 'pointy', mark: 'none', base: 'P17', muzzle: 'P17', ear: 'P17', eye: 'P80' },
    { id: 'cat-tortie', name: 'Tortoiseshell', species: 'cat', ears: 'pointy', mark: 'calico', base: 'P18', muzzle: 'P18', ear: 'P18', mark1: 'P20', mark2: 'P90', eye: 'P03' },
    { id: 'cat-scottish', name: 'Scottish Fold', species: 'cat', ears: 'folded', mark: 'bicolor', base: 'P17', muzzle: 'P01', ear: 'P17', mark1: 'P01', eye: 'P57' }
  ];

  /* ------------------------------------------------------------------ *
   * Stamp a bitmap (text / template) into a grid
   * ------------------------------------------------------------------ */
  BY.stamp = function (dst, dw, dh, src, sw, sh, ox, oy, colorId) {
    for (var y = 0; y < sh; y++) for (var x = 0; x < sw; x++) {
      var v = src[y * sw + x];
      if (!v) continue;
      var X = ox + x, Y = oy + y;
      if (X < 0 || Y < 0 || X >= dw || Y >= dh) continue;
      dst[Y * dw + X] = colorId ? colorId : v;
    }
  };
})(window);
